import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

import { type ServiceLogger } from '@/shared/services/service-logger/service-logger';

import { type ServicesState } from './types';

const defaultServicesState = {
  loggerService: {} as ServiceLogger,
};

export const useServiceStateRaw = create<ServicesState>()((set) => ({
  ...defaultServicesState,
  actions: {
    hydrate: (fresh: Partial<ServicesState>) => set(fresh),
  },
}));

export const useServiceActions = () =>
  useServiceStateRaw(useShallow((state) => state.actions));

export const useLoggerService = () =>
  useServiceStateRaw(useShallow((state) => state.loggerService));
